import { render, staticRenderFns } from "./sso-authorize.vue?vue&type=template&id=51ecbfd4"
import script from "./sso-authorize.vue?vue&type=script&lang=js"
export * from "./sso-authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports